export const keyone = [
  { letter: "Q", color: "#d8d8d8" },
  { letter: "W", color: "#d8d8d8" },
  { letter: "E", color: "#d8d8d8" },
  { letter: "R", color: "#d8d8d8" },
  { letter: "T", color: "#d8d8d8" },
  { letter: "Y", color: "#d8d8d8" },
  { letter: "U", color: "#d8d8d8" },
  { letter: "I", color: "#d8d8d8" },
  { letter: "O", color: "#d8d8d8" },
  { letter: "P", color: "#d8d8d8" }
]

export const keytwo = [
  { letter: "A", color: "#d8d8d8" },
  { letter: "S", color: "#d8d8d8" },
  { letter: "D", color: "#d8d8d8" },
  { letter: "F", color: "#d8d8d8" },
  { letter: "G", color: "#d8d8d8" },
  { letter: "H", color: "#d8d8d8" },
  { letter: "J", color: "#d8d8d8" },
  { letter: "K", color: "#d8d8d8" },
  { letter: "L", color: "#d8d8d8" }
]

export const keythree = [
  { letter: "Z", color: "#d8d8d8" },
  { letter: "X", color: "#d8d8d8" },
  { letter: "C", color: "#d8d8d8" },
  { letter: "V", color: "#d8d8d8" },
  { letter: "B", color: "#d8d8d8" },
  { letter: "N", color: "#d8d8d8" },
  { letter: "M", color: "#d8d8d8" }
]
